import { useMemo, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants/routes'

import MuiButton from '@mui/material/Button'
import MuiContainer from '@mui/material/Container'

import PageTitle from '../../components/page-title'
import ClientList from './components/clientList'

const Clients = () => {
  const navigate = useNavigate()

  const onAddClientClick = useCallback(() => {
    navigate(`${ROUTES.CLIENTS}/new`, { replace: true })
  }, [navigate])

  const action = useMemo(
    () => (
      <MuiButton variant="outlined" onClick={onAddClientClick}>
        Add Client
      </MuiButton>
    ),
    [onAddClientClick]
  )

  return (
    <>
      <PageTitle title="Clients" action={action} />
      <MuiContainer maxWidth={false} disableGutters>
        <ClientList />
      </MuiContainer>
    </>
  )
}

export default Clients
